export default {
  PK10: {
    '[01]': ['135deg', '#FFC400', '#E69D00'],
    '[02]': ['135deg', '#00beff', '#007de9'],
    '[03]': ['135deg', '#7a7a82', '#484850'],
    '[04]': ['135deg', '#ffab05', '#d75b00'],
    '[05]': ['135deg', '#5ff1fd', '#31bdd0'],
    '[06]': ['135deg', '#2b7af2', '#003e9d'],
    '[07]': ['135deg', '#d6d6de', '#aaaab2'],
    '[08]': ['135deg', '#f36f66', '#d63730'],
    '[09]': ['135deg', '#d01d1d', '#760404'],
    '[10]': ['135deg', '#51e30a', '#23b800']
  },
  BL28: {
    '[00, 13, 14, 27]': ['#f0f0f8'],
    '[01, 04, 07, 10, 16, 19, 22, 25]': ['135deg', '#51e30a 1%', '#23b800'],
    '[02, 05, 08, 11, 17, 20, 23, 26]': ['135deg', '#00beff', '#007de9'],
    '[03, 06, 09, 12, 15, 18, 21, 24]': ['135deg', '#f36f66', '#d63730']
  },
  CA28: {
    '[00, 13, 14, 27]': ['#f0f0f8'],
    '[01, 04, 07, 10, 16, 19, 22, 25]': ['135deg', '#51e30a 1%', '#23b800'],
    '[02, 05, 08, 11, 17, 20, 23, 26]': ['135deg', '#00beff', '#007de9'],
    '[03, 06, 09, 12, 15, 18, 21, 24]': ['135deg', '#f36f66', '#d63730']
  },
  LHC6: {
    '[05, 06, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]': ['135deg', '#51e30a 1%', '#23b800'],
    '[03, 04, 09, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48]': ['135deg', '#00beff', '#007de9'],
    '[01, 02, 07, 08, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46]': ['135deg', '#f36f66', '#d63730']
  },
  default: {
    '[]': ['133deg', '#ffc400 -22%', '#ff4081 51%', '#aa00ff 123%']
  }
}
